/*
 * @Description: 任务详情对应字段
 * @Date: 2020-01-06 13:23:55
 */
import createField from './tableDetailFields'; // 其中包含了列表与详情的字段
import { $$Seat } from './tool';
const map = {
  '1_0': [
    'fullName',
    'phone',
    'customerName',
    'hospitalName',
    'departmentName',
    'dutyName',
    'visitTime',
    'visitMinute',
    'commonImg_U_0123_addressWatermarkPicUrl',
    'commonEmpty_U_123_visitAddress',
    {
      prop: 'visitAddress',
      use: [0]
    },
    'commonImg_U_23_pics',
    {
      prop: 'messages',
      use: [0, 1, 2, 3]
    },
    'commonImg_U_1_autographPicUrl',
    'customerRemark',
    'product_name',
    'jixing',
    'guige',
    'approval_number'
  ], // 学术
  '9_0': [
    'fullName',
    'phone',
    'customerName',
    'hospitalName',
    'gradeName',
    'departmentName',
    'dutyName',
    'visitTime',
    'visitMinute',
    'commonImg_U_0123_addressWatermarkPicUrl',
    'commonEmpty_U_0123_visitAddress',
    'commonImg_U_23_pics',
    'common_U123_messages',
    'commonImg_U_1_autographPicUrl',
    'customerRemark',
    'product_name',
    'jixing',
    'guige',
    'approval_number'
  ], // 等级医院拜访
  '10_0': [
    'fullName',
    'phone',
    'customerName',
    {
      prop: 'hospitalName',
      label: '医疗机构'
    },
    {
      prop: 'gradeName',
      label: '医疗机构类别'
    },
    'departmentName',
    'visitTime',
    'visitMinute',
    'commonImg_U_0123_addressWatermarkPicUrl',
    'commonEmpty_U_0123_visitAddress',
    'commonImg_U_23_pics',
    'common_U123_messages',
    'commonImg_U_1_autographPicUrl',
    'customerRemark',
    'product_name',
    'jixing',
    'guige',
    'approval_number'
  ], // 基层医疗机构拜访
  '2_0': [
    {
      prop: 'enterpriseName',
      label: '发单企业'
    },
    'projectName',
    'pharmacyName',
    'startDt',
    'addressPicUrl',
    {
      prop: 'visitAddress',
      label: '药店定位'
    },
    'productName',
    'price',
    {
      prop: 'salesPrice',
      label: '产品售价'
    },
    'productRequire',
    'displayStatus',
    'isProdectPop',
    'isKnow',
    'imgUrl$0',
    'imgUrl$1',
    'imgUrl$2',
    'competitor',
    'stock'
  ], // OTC拜访
  '3_0': [
    'hospital',
    'meetingMinute',
    'messages',
    'customerRemark',
    'addressPicUrl',
    'visitAddress',
    'imgUrl$detail',
    'signInfo'
  ], // 科室会-记录
  '4_0': [
    'full_name',
    {
      label: '会议地址',
      prop: 'visitAddress'
    },
    {
      label: '会议时长(分钟)',
      prop: 'meetingMinute'
    },
    {
      label: '拜访定位',
      prop: 'longitudeAndLatitude'
    },
    'addressPicUrl',
    'customerFeedback',
    'signCount',
    'startdtChn',
    'urls',
    'signInfo'
  ], // 患教会-记录
  '11_0': [
    'fullName',
    'phone',
    'customerName',
    'hospitalName',
    'gradeName',
    'departmentName',
    'dutyName',
    'visitTime',
    'visitMinute',
    'commonImg_U_0123_addressWatermarkPicUrl',
    'commonEmpty_U_0123_visitAddress',
    'commonImg_U_23_pics',
    'common_U123_messages',
    'commonImg_U_1_autographPicUrl',
    'customerRemark',
    'product_name',
    'jixing',
    'guige',
    'approval_number'
  ], // 特级三甲医院市场准入-记录
  '12_0': [
    'fullName',
    'phone',
    'customerName',
    'hospitalName',
    'gradeName',
    'departmentName',
    'dutyName',
    'visitTime',
    'visitMinute',
    'commonImg_U_0123_addressWatermarkPicUrl',
    'commonEmpty_U_123_visitAddress',
    'commonImg_U_23_pics',
    'common_U123_messages',
    'commonImg_U_1_autographPicUrl',
    'customerRemark',
    'product_name',
    'jixing',
    'guige',
    'approval_number'
  ], // 三级医院市场准入-记录
  '13_0': [
    'fullName',
    'phone',
    'customerName',
    'hospitalName',
    'gradeName',
    'departmentName',
    'dutyName',
    'visitTime',
    'visitMinute',
    'commonImg_U_0123_addressWatermarkPicUrl',
    'commonEmpty_U_0123_visitAddress',
    'commonImg_U_23_pics',
    'common_U123_messages',
    'commonImg_U_1_autographPicUrl',
    'customerRemark',
    'product_name',
    'jixing',
    'guige',
    'approval_number'
  ], // 二级医院市场准入-记录
  '14_0': [
    'fullName',
    'phone',
    'customerName',
    'hospitalName',
    'gradeName',
    'departmentName',
    'dutyName',
    'visitTime',
    'visitMinute',
    'commonImg_U_0123_addressWatermarkPicUrl',
    'commonEmpty_U_0123_visitAddress',
    'commonImg_U_23_pics',
    'common_U123_messages',
    'commonImg_U_1_autographPicUrl',
    'customerRemark',
    'product_name',
    'jixing',
    'guige',
    'approval_number'
  ], // 基层医疗机构市场准入-记录
  '8_0': [
    {
      label: '标题',
      prop: 'title'
    },
    'bingliImg',
    'bingliFile',
    'content'
  ], // 医学病例收集-记录
  '18_0': [
    {
      label: '标题',
      prop: 'title'
    },
    'bingliImg',
    'bingliFile',
    'content'
  ] // 病例收集-记录
};
/**
 * @description: 搜索对应字段
 * @param {string, number}  type 项目类型_index(0|1) taxCollectionPattern 大类类型(四|三|三)
 * @return: searchFilter(copy)
 */
export default function(type, taxCollectionPattern) {
  let copy = map[type] ? [...map[type]] : null;
  if (taxCollectionPattern === 5 && copy) {
    copy.forEach((item, index) => {
      if (['fullName', 'full_name'].includes(item)) {
        copy[
          index
        ] = `${item}$$R_${taxCollectionPattern}=[{"label": "经营者","prop": "${item}"},"zooidEnterpriseName"]`;
      }
    });
  }
  if (taxCollectionPattern === 9 && copy) {
    copy.forEach((item, index) => {
      if (['fullName', 'full_name'].includes(item)) {
        copy[
          index
        ] = `${item}$$R_${taxCollectionPattern}=[{"label": "项目参与人","prop": "${item}"},"zooidEnterpriseName"]`;
      }
    });
  }
  if (copy) {
    let seat = $$Seat(copy, taxCollectionPattern);
    return createField(seat);
  }
  return null;
}
